<template>
    <div style="color: gray;float: right">
        Neuron {{ env }} version <span class="version">{{ neuron_version }}</span> - LMS <span class="version">{{ lms_version }}</span>
    </div>
</template>

<script>
export default {
    name: "SystemInfo",
    computed: {
        env() {
            return ENV.NODE_ENV.capitalize()
        },
        neuron_version() {
            return ENV.VUE_APP_NEURON_VERSION
        },
        lms_version() {
            return ENV.VUE_APP_LMS_VERSION
        }
    }
}
</script>

<style scoped lang="scss">
.version {
    text-decoration: underline;
}
</style>
